/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { apiUrl } from "../../Constants";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getBookingList: (params) => {
    return axios.get(API_ENDPOINTS.GET_BOOKINGS_LIST, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  createBooking: (data) => {
    return axios.post(API_ENDPOINTS.GET_BOOKINGS_LIST, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  createBookingV2: (data) => {
    return axios.post(API_ENDPOINTS.CREATE_BOOKINGS_V2, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getBookingById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_BOOKINGS_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  confirmBooking: (id) => {
    return axios.patch(`${API_ENDPOINTS.GET_BOOKINGS_LIST}/${id}/confirm`, {}, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  cancelBooking: (id) => {
    return axios.patch(`${API_ENDPOINTS.GET_BOOKINGS_LIST}/${id}/cancel`, {}, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  updateBooking: (id, data) => {
    return axios.patch(`${API_ENDPOINTS.GET_BOOKINGS_LIST}/${id}`, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deleteBooking: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_BOOKINGS_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  downloadBookingPdf: (id) => {
    return axios.get(`${apiUrl}/api/v1/report-template/bookings/${id}/pdf`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      responseType: "blob",
    });
  },
};
